import { api, USER_ABOUT_TAG } from '@/api';
import { handleQueryLifecycle } from '@/api/utils';
import { setUserPreferences } from '@/store';

export interface UpdateUserPreferencesRequest {
  enterToSend: boolean;
}

export interface UpdateUserPreferencesResponse {
  enterToSend: boolean;
}

export const userUpdatePreferencesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postUserUpdatePreferences: builder.mutation<UpdateUserPreferencesResponse, UpdateUserPreferencesRequest>({
      query: ({ enterToSend }) => ({
        url: 'user/update-preferences',
        method: 'POST',
        params: { enterToSend },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await handleQueryLifecycle(queryFulfilled, (data) => {
          dispatch(setUserPreferences(data));
          dispatch(api.util.invalidateTags([USER_ABOUT_TAG]));
        });
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { usePostUserUpdatePreferencesMutation } = userUpdatePreferencesApi;
